import { createChatInstance } from '@leagueplatform/chat';

// No appClient: EOS has no third-party human-agent chat service wired, so the
// instance runs with the SDK's AI client only.
export const chatInstance = createChatInstance();
